import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { orderGridReloadSubject } from '../../../../store/orders/grid/orders.grid.observables';
import { silentRequestGetOrders } from '../../../../store/orders/orders.actions';

const OrderGridReloadListener = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const subscription = orderGridReloadSubject.subscribe(() => dispatch(silentRequestGetOrders()));

    return () => subscription.unsubscribe();
  }, [dispatch]);

  return null;
};

export default OrderGridReloadListener;
